import { useAppSelector } from 'app/state'
import { useMemo } from 'react'
import { MapDatasetEnriched } from '../types'

function useDatasetsEnriched() {
  const datasetsKepler = useAppSelector((state) => state.keplerGl.map?.visState?.datasets)
  const datasets = useAppSelector((state) => state.maps.currentMapDatasets)

  const datasetsEnriched: MapDatasetEnriched[] = useMemo(() => {
    if (!(datasets && datasetsKepler)) return []

    return datasets.map((dataset) => {
      const id = dataset.id
      return id && id in datasetsKepler ? { ...datasetsKepler[id], ...dataset } : dataset
    })
  }, [datasets, datasetsKepler])

  return { datasetsEnriched, datasetsKepler, datasets }
}

export default useDatasetsEnriched
